import { render, staticRenderFns } from "./QuestionnaireList.vue?vue&type=template&id=ec4cff4e&"
import script from "./QuestionnaireList.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireList.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports